import React from "react";
import { Icon, type IconName } from "../Icon";

interface EmptyStateProps {
  iconName?: IconName;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  iconName,
  title,
  description,
  action,
  className = "",
}) => (
  <div className={"ds-empty " + className}>
    {iconName && (
      <div className="ds-empty-icon">
        <Icon name={iconName} size={28} />
      </div>
    )}
    {title && <div className="ds-empty-title">{title}</div>}
    {description && <div className="ds-empty-desc">{description}</div>}
    {action && <div className="ds-empty-action">{action}</div>}
  </div>
);
